import { render, staticRenderFns } from "./ColumnPermission.vue?vue&type=template&id=0c6cec69&"
import script from "./ColumnPermission.vue?vue&type=script&lang=js&"
export * from "./ColumnPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports